module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Fc-Ge-Ha-Ia.0eacdd9b.png";